import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHashtag, faCalendar, faClock } from "@fortawesome/pro-solid-svg-icons";

import { isDateValid } from "../../../../util";

import "./index.scss";

const AppointmentInfo = ({ appointment, t }) => {
  const hasDueIn = isDateValid(appointment.due_in);
  const hasTimeCarApp = isDateValid(appointment.time_car_app);

  return (
    <div className="desk-comm-appointment-info">
      <div className="desk-comm-cell">
        <span className="desk-comm-label">
          {t("cc_wo_nr").message || "WO"} <FontAwesomeIcon icon={faHashtag} className="i-green" />
        </span>
        <span className="desk-comm-value">{appointment.wo_nr}</span>
      </div>

      <div className="desk-comm-cell">
        <span className="desk-comm-label">
          {t("cc_reg").message || "Reg."} <FontAwesomeIcon icon={faHashtag} className="i-green" />
        </span>
        <span className="desk-comm-value">{appointment.reg_number}</span>
      </div>

      {appointment.vin_nr && (
        <div className="desk-comm-cell">
          <span className="desk-comm-label">
            {t("cc_VIN").message || "VIN"} <FontAwesomeIcon icon={faHashtag} className="i-green" />
          </span>
          <span className="desk-comm-value">{appointment.vin_nr}</span>
        </div>
      )}

      {hasDueIn && (
        <>
          <div className="desk-comm-cell">
            <FontAwesomeIcon icon={faCalendar} className="i-green" />
            <span className="desk-comm-value">{moment(appointment.due_in).format("DD-MM-YYYY")}</span>
          </div>
          <div className="desk-comm-cell">
            <FontAwesomeIcon icon={faClock} className="i-green" />
            <span className="desk-comm-value">{moment(appointment.due_in).format("HH:mm")}</span>
          </div>
        </>
      )}

      {hasTimeCarApp && !hasDueIn && (
        <div className="desk-comm-cell">
          <FontAwesomeIcon icon={faCalendar} className="i-green" />
          <span className="desk-comm-value">{moment(appointment.time_car_app).format("DD-MM-YYYY")}</span>
        </div>
      )}
    </div>
  );
};

export default AppointmentInfo;
